import { Box, styled } from '@mui/material'
import DetailCrossBackground from '@src/components/share/detail/DetailCrossBackground'
import React from 'react'

const Container = styled(DetailCrossBackground)`
  .Custom-Content {
    padding: 20px;
    display: flex;
    gap: 20px;
    width: 100%;
  }
`

const InnerBox = styled(Box)`
  background: #333536;
  height: 100%;
  width: 100%;
  flex: 1;
`

export const SectionContent: React.FC<SectionContentProps> = props => {
  const { className, children } = props

  return (
    <Box className={className}>
      <Container className='Custom-Container'>
        <InnerBox className='Custom-Inner-Box'>{children}</InnerBox>
      </Container>
    </Box>
  )
}

export type SectionContentProps = {
  className?: string
  children?: React.ReactNode
}
